import React from 'react';
import '../../assets/styles/SuperAdmin/SATheme.css';
import '../../assets/styles/SuperAdmin/SAAuditLog.css';

const SAAuditLog = ({ logs }) => {
    const exportCsv = () => {
        if (!logs || logs.length === 0) { alert('No logs to export'); return; }
        const headers = ['Timestamp', 'Action', 'Detail', 'User', 'Role'];
        const rows = logs.map(l => [
            (l.timestamp_str || l.time || l.created_at || '').replace(/"/g, '""'),
            (l.action || '').replace(/"/g, '""'),
            (l.detail || '').replace(/"/g, '""'),
            (l.user_name || l.user || '').replace(/"/g, '""'),
            (l.role || '').replace(/"/g, '""')
        ]);
        const csvContent = [headers.join(','), ...rows.map(r => r.map(c => `"${c}"`).join(','))].join('\n');
        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `audit-log-${new Date().toISOString().slice(0, 10)}.csv`;
        a.click();
        URL.revokeObjectURL(a.href);
    };
    return (
        <div className="animate-in">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }}>
                <div>
                    <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, fontFamily: "'Sora'" }}>Audit Trail</h2>
                    <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--sa-muted)" }}>Immutable log of all administrative actions and system modifications</p>
                </div>
                <button onClick={exportCsv} style={{ background: "transparent", color: "var(--sa-dim)", border: "1px solid var(--sa-border)", padding: "8px 16px", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>📄 Export CSV</button>
            </div>

            <div className="sa-audit-container">
                {logs.map((log, i) => (
                    <div key={i} className="sa-audit-item" style={{ borderLeftColor: log.color }}>
                        <div className="sa-audit-icon" style={{ background: log.color + "14" }}>{log.icon}</div>
                        <div style={{ flex: 1 }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 2 }}>
                                <span style={{ fontSize: 14, fontWeight: 700, color: log.color }}>{log.action}</span>
                                <span style={{ fontSize: 11, color: "var(--sa-dim)" }}>{log.time}</span>
                            </div>
                            <div style={{ fontSize: 13, color: "var(--sa-muted)" }}>{log.detail}</div>
                        </div>
                        <div style={{ fontSize: 10, color: "var(--sa-dim)", fontWeight: 800, padding: "4px 8px", background: "var(--sa-bg)", borderRadius: 6, textTransform: "uppercase" }}>
                            # {String(1042 - i).padStart(4, '0')}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SAAuditLog;
